import { api } from '@/services/axios'

export interface ICreatePremio {
  descricao: string
  posicao: number
  campanha_Id: number
}

export interface IPremio extends ICreatePremio {
  id: number
  status_sorteio: string
  numero_sorteado?: number
  usuario_Ganhador_Id?: number
}

export async function createPremio(data: ICreatePremio) {
  const response = await api.post('CampanhaPremio/Create', data)
  return response.data
}

export async function getPremioById(id: number) {
  const response = await api.get(`CampanhaPremio/GetById/${id}`)
  return response.data
}

export async function deletePremio(id: number) {
  const response = await api.delete(`CampanhaPremio/Delete/${id}`)
  return response.data
}

export async function updatePremio(id: number, data: ICreatePremio) {
  const response = await api.put(`CampanhaPremio/Update/${id}`, data)
  return response.data
}

export async function getAllPremios(campanhaId: number) {
  const response = await api.get(`CampanhaPremio/GetAll`, {
    params: { campanhaId },
  })
  return response.data
}
